import { render, staticRenderFns } from "./Falecidos.vue?vue&type=template&id=55019658&scoped=true"
import script from "./Falecidos.vue?vue&type=script&lang=js"
export * from "./Falecidos.vue?vue&type=script&lang=js"
import style0 from "./Falecidos.vue?vue&type=style&index=0&id=55019658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55019658",
  null
  
)

export default component.exports